import React, { Suspense, useCallback, useMemo } from "react";
import { Form, SelectProps } from "semantic-ui-react";
import IFormType from "../../interfaces/IFormType";
import { DefaultSelectPlaceholder } from "../DefaultSelectPlaceholder";
import { RenderFormTypes } from "./RenderFormTypes";


interface FormTypeSelectProps extends Omit<SelectProps, "onChange" | "value" | "options"> {
    value?: IFormType["id"];
    onChange: (value?: IFormType["id"]) => void;
    formTypes?: IFormType[];
};

const FormTypeSelectBase: React.FC<FormTypeSelectProps> = ({
    formTypes,
    onChange,
    value,
    ...selectProps
}) => {

    const options = useMemo(() => formTypes ?
        formTypes.map((formType) => ({ text: formType.name, value: formType.id }))
        : [],
        [formTypes])

    const updateValue: SelectProps["onChange"] = (_1, { value }) => {
        onChange(value ? value as any : undefined);
    }

    return (
        <Form.Select
            fluid
            options={options}
            value={value}
            disabled={!formTypes}
            onChange={updateValue}
            {...selectProps}
        />
    )
};


export const FormTypeSelect: React.FC<FormTypeSelectProps> = (props) => {
    return (
        <Suspense fallback={<DefaultSelectPlaceholder {...props} />}>
            <RenderFormTypes
                render={({ formTypes }) => (
                    <FormTypeSelectBase formTypes={formTypes} {...props} />
                )}
            />
        </Suspense>
    );
};